<template>
  <div class="yq-information">
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="flexBox">
      <text-title :mainTitle="mainTitle" :subheading="subheading" />
      <div class="header-btn-box">
        <!--<a @click="toModifyPage" v-if="permissionCodes.indexOf('001001001') !== -1">修改</a>-->
        <a @click="toModifyPage" class="modify-btn" v-if="permissionCodes.indexOf('001001001') !== -1"><i class="iconfont el-icon-damai-shenpi" style="margin-right:4px"></i>修改</a>
      </div>
    </div>
    <form class="yq-information-form">
      <div class="form-left">
        <div class="form-top-text">
          <img src="../../../assets/basicMessage.png" alt="" style="display:inline-block;vertical-align:middle;">
          基础信息
        </div>
        <div class="form-left-line">
          <div class="line-text">公寓名称：</div>
          {{ formData.yqName || "无" }}
          <!-- <el-input
            class="line-info"
            v-model="formData.yqName || '无'"
            size="small"
            disabled
          /> -->
        </div>
        <div class="form-left-line">
          <div class="line-text">公寓联系方式：</div>
          {{formData.managerPhone || '无'}}
          <!-- <el-input
            class="line-info"
            v-model="formData.managerPhone || '无'"
            size="small"
            disabled
          /> -->
        </div>
        <div class="form-left-line">
          <div class="line-text">公寓Logo：</div>
          <div class="line-info">
            <img
              :src="formData.yqLogo"
              alt=""
              v-if="formData.yqLogo"
              style="width: auto; height: 50px; max-width: 150px"
            />
            <span v-if="!formData.yqLogo">无</span>
          </div>
        </div>
        <div class="form-left-line">
          <div class="line-text">标准层高：</div>
          {{formData.floorStandardHigh || '0'}}m
          <!-- <el-input
            class="line-info"
            v-model="formData.floorStandardHigh || '0'"
            size="small"
            disabled
          > -->
            <template slot="append">m</template>
          </el-input>
        </div>
        <div class="form-left-line">
          <div class="line-text">标准层面积：</div>
          {{formData.floorStandardArea || '0'}}m²
          <!-- <el-input
            class="line-info"
            v-model="formData.floorStandardArea || '0'"
            size="small"
            disabled
          > -->
            <template slot="append">m²</template>
          </el-input>
        </div>
        <div class="form-left-line">
          <div class="line-text">佣金规则：</div>
          {{formData.commissionRules || '无'}}
          <!-- <el-input
            class="line-info"
            v-model="formData.commissionRules || '无'"
            size="small"
            disabled
          /> -->
        </div>
        <div class="form-left-line">
          <div class="line-text">物业公司：</div>
          {{formData.propertyCompany || '无'}}
          <!-- <el-input
            class="line-info"
            v-model="formData.propertyCompany || '无'"
            size="small"
            disabled
          /> -->
        </div>
        <div class="form-left-line">
          <div class="line-text">交付运营时间：</div>
          {{formData.startOperationTime || '无'}}
          <!-- <el-input
            class="line-info"
            v-model="formData.startOperationTime || '无'"
            size="small"
            disabled
          /> -->
        </div>
        <div class="form-left-line">
          <div class="line-text">交付标准：</div>
          {{formData.roomDecoration || '无'}}
          <!-- <el-input
            class="line-info"
            v-model="formData.roomDecoration || '无'"
            size="small"
            disabled
          /> -->
        </div>
        <div class="form-left-line">
          <div class="line-text">公寓租赁单价：</div>
          {{formData.yqUnitPrice || '0'}}(元 / m² / 天)
          <!-- <el-input
            class="line-info"
            v-model="formData.yqUnitPrice || '0'"
            size="small"
            disabled
          > -->
<!--            <template slot="append">元 / m² / 天</template>-->
<!--          </el-input>-->
        </div>
        <div class="form-left-line">
          <div class="line-text">公寓物业单价：</div>
          {{formData.propertyFee || '0'}}(元 / m² / 月)
          <!-- <el-input
            class="line-info"
            v-model="formData.propertyFee || '0'"
            size="small"
            disabled
          > -->
<!--            <template slot="append">元 / m² / 天</template>-->
<!--          </el-input>-->
        </div>
        <div class="form-left-line">
          <div class="line-text">公寓标签：</div>
          <div
            class="line-info"
            v-if="formData.dynamicTags.length > 0"
            style="
              flex: 1;
              width: auto;
              display: flex;
              justify-content: flex-start;
              flex-wrap: wrap;
            "
          >
            <el-tag
              :key="tag"
              v-for="tag in formData.dynamicTags"
              style="margin: 10px 10px 10px 0"
              >{{ tag }}</el-tag
            >
          </div>
          <div class="line-info" v-else>无</div>
        </div>
        <!--        <div class="form-left-line" style="align-items: flex-start">-->
        <!--          <div class="line-text">公寓介绍：</div>-->
        <!--          <el-input class="line-info" v-model="formData.yqIntroduce || '无'" type="textarea" :rows="5" size="small" disabled />-->
        <!--        </div>-->
        <div class="form-left-line">
          <div class="line-text" style="line-height: initial">公寓展示：</div>
          <div style="width: 240px; height: 135px" v-if="picList.length !== 0">
            <el-carousel height="180px">
              <el-carousel-item v-for="item in picList" :key="item">
                <img :src="item" alt="" style="width: 240px; height: 135px" />
              </el-carousel-item>
            </el-carousel>
          </div>
          <div v-if="picList.length === 0">暂无</div>
        </div>
      </div>

      <div class="form-right">
        <!-- <div class="form-right-top">
          <div class="form-top-text">
            <img src="../../../assets/address.png" alt="" style="display:inline-block;vertical-align:middle;">
            </i>公寓地址
          </div>
          <div class="form-left-line">
            <div style="width: 480px; margin: 10px auto">
              <div style="font-size: 14px;margin-left:150px">
                <i
                  class="iconfont el-icon-damai-weizhi"
                  style="color: #00a0e6; font-size: 16px; margin-bottom: 10px"
                ></i
                >{{ formData.yqAddress }}
              </div>
              <garden-map
                :isModify="false"
                :longitude="formData.longitude"
                :latitude="formData.latitude"
              />
            </div>
          </div>
        </div> -->
        <div class="form-right-bottom">
          <div class="form-top-text">
            <img src="../../../assets/intro.png" alt="" style="display:inline-block;vertical-align:middle;"></i>公寓简介
          </div>
          <div class="editorBox">
            <quill-editor
              ref="QuillEditor"
              v-model="formData.yqIntroduceOnPage"
              class="ql-editor"
              :options="editorOption"
              disabled
            >
            </quill-editor>
          </div>
        </div>
      </div>
    </form>
    <!--    <form>-->
    <!--      <div class="form-line">-->
    <!--        <div style="display: flex;justify-content: flex-start;margin-bottom: 20px;">-->
    <!--          <div class="line-text">公寓名称：</div>-->
    <!--          <div class="line-info">{{formData.yqName || '无'}}</div>-->
    <!--        </div>-->
    <!--        <div style="display: flex;justify-content: flex-start;margin-bottom: 20px;">-->
    <!--          <div class="line-text">公寓联系方式：</div>-->
    <!--          <div class="line-info">{{formData.managerPhone || '无'}}</div>-->
    <!--        </div>-->
    <!--        <div style="display: flex;justify-content: flex-start">-->
    <!--          <div class="line-text">公寓Logo：</div>-->
    <!--          <div class="line-info">-->
    <!--            <img :src="formData.yqLogo" alt="" v-if="formData.yqLogo" style="width: auto;height: 50px;max-width: 150px;">-->
    <!--            <span v-if="!formData.yqLogo">无</span>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->

    <!--      <div class="form-line">-->
    <!--        <div style="display: flex;justify-content: flex-start;margin-bottom: 20px;">-->
    <!--          <div class="line-text">标准层高：</div>-->
    <!--          <div class="line-info" v-if="formData.floorStandardHigh">{{formData.floorStandardHigh || '0'}}m</div>-->
    <!--          <div class="line-info" v-else>无</div>-->
    <!--        </div>-->
    <!--        <div style="display: flex;justify-content: flex-start;margin-bottom: 20px;">-->
    <!--          <div class="line-text">标准层面积：</div>-->
    <!--          <div class="line-info" v-if="formData.floorStandardArea">{{formData.floorStandardArea || '0'}}m²</div>-->
    <!--          <div class="line-info" v-else>无</div>-->
    <!--        </div>-->
    <!--        <div style="display: flex;justify-content: flex-start;margin-bottom: 20px;">-->
    <!--          <div class="line-text">佣金规则：</div>-->
    <!--          <div class="line-info">{{formData.commissionRules || '无'}}</div>-->
    <!--        </div>-->
    <!--      </div>-->

    <!--      <div class="form-line">-->
    <!--        <div style="display: flex;justify-content: flex-start;margin-bottom: 20px;">-->
    <!--          <div class="line-text">物业公司：</div>-->
    <!--          <div class="line-info">{{formData.propertyCompany || '无'}}</div>-->
    <!--        </div>-->
    <!--        <div style="display: flex;justify-content: flex-start;margin-bottom: 20px;">-->
    <!--          <div class="line-text">交付运营时间：</div>-->
    <!--          <div class="line-info">{{formData.startOperationTime || '无'}}</div>-->
    <!--        </div>-->
    <!--        <div style="display: flex;justify-content: flex-start;margin-bottom: 20px;">-->
    <!--          <div class="line-text">交付标准：</div>-->
    <!--          <div class="line-info">{{formData.roomDecoration || '无'}}</div>-->
    <!--        </div>-->
    <!--      </div>-->

    <!--      <div class="form-line">-->
    <!--        <div style="display: flex;justify-content: flex-start;margin-bottom: 20px;">-->
    <!--          <div class="line-text">公寓租赁单价：</div>-->
    <!--          <div class="line-info" v-if="formData.yqUnitPrice">{{formData.yqUnitPrice || '0'}}元 / m² / 天</div>-->
    <!--          <div class="line-info" v-else>无</div>-->
    <!--        </div>-->
    <!--        <div style="display: flex;justify-content: flex-start;margin-bottom: 20px;">-->
    <!--          <div class="line-text">公寓物业单价：</div>-->
    <!--          <div class="line-info" v-if="formData.propertyFee">{{formData.propertyFee || '0'}}元 / m² / 天</div>-->
    <!--          <div class="line-info" v-else>无</div>-->
    <!--        </div>-->
    <!--        <div style="display: flex;justify-content: flex-start;margin-bottom: 20px;">-->
    <!--          <div class="line-text"></div>-->
    <!--          <div class="line-info"></div>-->
    <!--        </div>-->
    <!--      </div>-->

    <!--      <div class="form-line">-->
    <!--        <div style="display: flex;justify-content: flex-start;margin-bottom: 20px;">-->
    <!--          <div class="line-text">公寓标签：</div>-->
    <!--          <div class="line-info" v-if="formData.dynamicTags.length > 0" style="flex: 1;width: auto;display: flex;justify-content: flex-start;flex-wrap: wrap">-->
    <!--            <el-tag :key="tag" v-for="tag in formData.dynamicTags" style="margin: 10px 10px 10px 0;">{{tag}}</el-tag>-->
    <!--          </div>-->
    <!--          <div class="line-info" v-else>无</div>-->
    <!--        </div>-->
    <!--      </div>-->

    <!--      <div class="form-line" style="margin-top: 20px;">-->
    <!--        <div>-->
    <!--          <div class="line-text" style="line-height: initial">公寓介绍：</div>-->
    <!--          <div class="yq_introduce_box">-->
    <!--            <div v-for="item in yqIntroduceList" v-if="yqIntroduceList.length > 0">{{item}}</div>-->
    <!--            <div v-else>无</div>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--        <div>-->
    <!--          <div class="line-text" style="line-height: initial">公寓展示：</div>-->
    <!--          <div style="width: 320px;height: 180px;" v-if="picList.length !== 0">-->
    <!--            <el-carousel height="180px">-->
    <!--              <el-carousel-item v-for="item in picList" :key="item">-->
    <!--                <img :src="item" alt="" style="width: 320px;height: 180px;">-->
    <!--              </el-carousel-item>-->
    <!--            </el-carousel>-->
    <!--          </div>-->
    <!--          <div v-if="picList.length === 0">暂无</div>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--      <div class="form-line" style="margin-top: 40px;">-->
    <!--        <div>-->
    <!--          <div class="line-text" style="line-height: initial">公寓地址：</div>-->
    <!--          <div>-->
    <!--            <div style="font-size: 14px;"><i class="iconfont el-icon-damai-weizhi" style="color: #00A0E6;font-size: 16px;margin-bottom: 10px;"></i>{{formData.yqAddress}}</div>-->
    <!--            <garden-map :isModify="false" :longitude="formData.longitude" :latitude="formData.latitude" />-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </form>-->
  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import TextTitle from "../../../components/Text/TextTitle";
import { api } from "../../api/ConfigRoutine";
import { errorHandler } from "../../../utils/errorHandler";
import GardenMap from "../../../components/Map/GardenMap";
import { bus } from "../../../utils/bus";

const toolbarOptions = [
  ["bold", "italic", "underline", "strike"], // toggled buttons
  ["blockquote", "code-block"],

  [{ header: 1 }, { header: 2 }], // custom button values
  [{ list: "ordered" }, { list: "bullet" }],
  [{ script: "sub" }, { script: "super" }], // superscript/subscript
  [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
  [{ direction: "rtl" }], // text direction

  [{ size: ["small", false, "large", "huge"] }], // custom dropdown
  [{ header: [1, 2, 3, 4, 5, 6, false] }],

  [{ color: [] }, { background: [] }], // dropdown with defaults from theme
  [{ font: [] }],
  [{ align: [] }],
  ["link", "image"],
  ["clean"], // remove formatting button
];

export default {
  components: {
    GardenMap,
    TextTitle,
    Breadcrumb,
  },
  name: "yq-information",
  data() {
    return {
      permissionCodes: "",
      breadcrumb: [
        {
          value: "资源中心",
          name: "yq-information",
        },
        {
          value: "公寓信息",
        },
      ],
      mainTitle: "公寓信息",
      // subheading: "设置接入公寓的名称，公寓背景图等",
      yqIntroduceList: [],
      formData: {
        yqName: "",
        yqLogo: "",
        yqIconUrl: "",
        yqBackgroundUrl: "",
        propertyFee: "",
      },
      picList: [],

      editorOption: {
        modules: {
          toolbar: {
            container: toolbarOptions, // 工具栏
            handlers: {
              image: function (value) {
                if (value) {
                  document.querySelector("#showImageDialogVisible").click();
                } else {
                  this.quill.format("image", false);
                }
              },
            },
          },
        },
      },
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
    this.getYqInfo();
  },
  mounted() {},
  methods: {
    toModifyPage() {
      this.$router.push({
        name: "modify-yq-information",
      });
    },
    getYqInfo() {
      this.$axios
        .post(api.getYqInfo, {})
        .then((res) => {
          if (res.data.retCode === 1) {
            let data = res.data.data;
            data.yqIntroduceOnPage = decodeURI(data.yqIntroduce);
            this.formData = data;
            if (this.formData.yqTaps) {
              this.formData.dynamicTags = this.formData.yqTaps.split("&&");
            } else {
              this.formData.dynamicTags = [];
            }
            // this.yqIntroduceList = data.yqIntroduce.split('\n')
            if (data.yqPic1) {
              this.picList.push(data.yqPic1);
            }
            if (data.yqPic2) {
              this.picList.push(data.yqPic2);
            }
            if (data.yqPic3) {
              this.picList.push(data.yqPic3);
            }
            if (data.yqPic4) {
              this.picList.push(data.yqPic4);
            }
            if (data.yqPic5) {
              this.picList.push(data.yqPic5);
            }
            if (data.yqApartmentLayoutDiagramList) {
              let yqApartmentLayoutDiagramListArr = data.yqApartmentLayoutDiagramList.split(
                ","
              );
              yqApartmentLayoutDiagramListArr.map((v) => {
                this.picList.push(v);
              });
            }
          }
        })
        .catch(errorHandler("查询公寓信息失败"));
    },
  },
};
</script>

<style scoped>
.flexBox {
  display: flex;
  justify-content: space-between;
}
.header-btn-box {
  margin: 20px 0 10px 0;
  color: #337ab7;
  font-size: 14px;
}
.modify-btn{
            display: inline-block;
            width: 80px;
            height: 32px;
            line-height: 32px;
            background: #1362ff;
            border-radius: 4px;
            font-size: 14px;
            color: #fff;

}
.header-btn-box a {
  margin-right: 40px;
  cursor: pointer;
}
.header-btn-box a:hover {
  background: #06b3ff;
}
form {
  width: 96%;
  margin: 0 auto;
  /*padding-right: 10%;*/
  text-align: left;
}
.form-line {
  margin: 10px 0;
  display: flex;
  justify-content: space-between;
}
.form-line > div {
  display: flex;
  justify-content: flex-start;
  line-height: 20px;
}
.line-text {
  color: #48576a;
  font-size: 14px;
  margin-right: 10px;
  width: 120px;
  /*height: 50px;*/
  /*line-height: 50px;*/
  text-align: right;
}
.line-info {
  width: 280px;
}
.yq_introduce_box {
  width: 330px;
  max-height: 240px;
  overflow-y: auto;
}
.yq_introduce_box > div {
  text-indent: 2em;
}
</style>

<style lang="less">
.yq-information {
  .el-carousel__button {
    width: 10px !important;
  }
  .yq-information-form {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    height: 740px;
    .form-top-text {
      font-size: 16px;
      padding: 0 10px;
      line-height: 40px;
      // background: #eeeeee;
      i {
        font-size: 18px;
        margin-right: 10px;
      }
    }
    .form-left {
      width: 420px;
      height: 100%;
      margin-right: 30px;
      border-radius: 7px;
      border: 1px solid #eeeeee;
      .form-left-line {
        margin: 10px 0;
        display: flex;
        justify-content: flex-start;
        align-items: center;
      }
    }
    .form-right {
      flex: 1;
      height: 100%;
      display: flex;
      justify-content: flex-start;
      flex-direction: column;
      .form-right-top {
        margin-bottom: 30px;
        border-radius: 7px;
        border: 1px solid #eeeeee;
      }
      .form-right-bottom {
        flex: 1;
        border-radius: 7px;
        border: 1px solid #eeeeee;
        display: flex;
        justify-content: flex-start;
        flex-direction: column;
        .editorBox {
          flex: 1;
          /deep/ .ql-editor {
            display: flex;
            justify-content: flex-start;
            flex-direction: column;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/ResourceCenter/YqInformation/YqInformation.vue